import { useEffect } from "react";
import axios from "axios";

const COOKIE_NAME = "nut_ref";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND}/api`;

function setCookie(value, days) {
  const expires = new Date(Date.now() + days * 86400_000).toUTCString();
  // SameSite=Lax so it survives the Paddle checkout iframe navigation.
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(value)}; path=/; expires=${expires}; SameSite=Lax`;
}

export function getRefCookie() {
  const match = document.cookie.match(new RegExp("(?:^|; )" + COOKIE_NAME + "=([^;]+)"));
  if (!match) return null;
  try {
    return JSON.parse(decodeURIComponent(match[1]));
  } catch (_) {
    return null;
  }
}

/**
 * Hook: inspect the current URL for ?ref=NUT-XXXXXX, validate server-side, and
 * drop a first-party cookie that will be read by the checkout step. Attribution
 * window + validity is enforced by the server at commission-calc time; the
 * cookie is just a hint.
 */
export function useReferralCapture() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const raw = (params.get("ref") || "").trim().toUpperCase();
    if (!raw) return;
    if (!/^NUT-[A-Z0-9]{4,10}$/.test(raw)) return;

    // Fire-and-forget: validate + record the click. If the affiliate is
    // suspended or unknown, server just returns ok:false and we don't cookie.
    axios
      .post(`${API}/affiliate/track-click`, {
        affiliate_id: raw,
        landing_path: window.location.pathname,
        referrer: document.referrer?.slice(0, 200) || null,
      })
      .then((r) => {
        const d = r.data || {};
        if (!d.ok || !d.affiliate_id) return;
        setCookie(
          JSON.stringify({ affiliate_id: d.affiliate_id, source: "link", click_id: d.click_id, exp: d.attribution_expires_at }),
          Math.max(1, Math.min(90, d.attribution_window_days || 30))
        );
      })
      .catch(() => {});
  }, []);
}
